import { render, staticRenderFns } from "./HistoryHeaderMenu.vue?vue&type=template&id=a08234dc&scoped=true"
import script from "./HistoryHeaderMenu.vue?vue&type=script&lang=js"
export * from "./HistoryHeaderMenu.vue?vue&type=script&lang=js"
import style0 from "./HistoryHeaderMenu.vue?vue&type=style&index=0&id=a08234dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08234dc",
  null
  
)

export default component.exports